/*
 * sT3r
 */
$(document).ready(function() {



  initMobileMenu();
  initFancybox();
  initSmallLayoutAnimations();
});


//user prefers no animations (OS accessibility setting)
function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

//FIX wrong 100vh in iOS and android jumps when the url bar hides
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
var vh = window.innerHeight * 0.01;
//this is than used as var inside css/less
document.documentElement.style.setProperty('--vh', vh+'px');